import { Component, h, Element, Listen, State } from "@stencil/core";
import {DATA_STORE_KEY_PREBOOK, dataStore} from '../../global/DataStore'
import { NjShoppingCartDialog } from "../nj-shopping-cart-dialog/nj-shopping-cart-dialog";
import { formatPrice } from "../../helpers/utils";

@Component({
  tag: "nj-shopping-cart-btn",
  styleUrl: "nj-shopping-cart-btn.scss",
  shadow: true
})

export class NjShoppingCartBtn {

    shoppingDialog: NjShoppingCartDialog

    @Element() el: HTMLElement;

    @State() prebookData: any = null
    @State() shoppingCartPrice: number = 0.00
    @State() private insurancePremium = 0;

    componentWillLoad() {
        this.loadPrices();
    }

    @Listen('sessionDataChanged', {target: 'window'})
    onSessionDataChanged(event: CustomEvent) {
        if (event.detail.sessionName == 'prebook') {
            this.loadPrices();
        }
    }

    @Listen('sessionDataRemoved', {target: 'window'})
    onSessionDataRemoved(event: CustomEvent) {
        if (event.detail.sessionName == 'prebook') {
            this.shoppingCartPrice = 0.0
            this.insurancePremium = 0;
        }
    }


    @Listen('prebookRequestPrepared',{ target: 'window' })
    onPrebookRequestPrepared() {
        this.loadPrices();
    }

    private loadPrices() {
        this.prebookData = dataStore().getSessionData(DATA_STORE_KEY_PREBOOK, this.prebookData)
        this.shoppingCartPrice = (this.prebookData ? this.prebookData.paymentInformation.amount : 0)
        this.insurancePremium = (this.prebookData?.insuranceSelected && this.prebookData.insurancePremium) ?? 0;
    }

    handleToggleClick(ev) {
        ev.preventDefault();
        ev.stopPropagation();

        this.shoppingDialog = document.querySelector('nj-shopping-cart-dialog') as any;
        this.shoppingDialog.toggle();
    }

    render()  {
        return(
            <div onClick={ev => this.handleToggleClick(ev)}>
                <button class="js-shopping-cart-btn shopping-cart-btn" onClick={(ev) => this.handleToggleClick(ev)}>
                    <span class="shopping-cart-btn__icon"><tickets-icon width={14} height={14} /></span>
                    <span class="js-shopping-price">{formatPrice(this.shoppingCartPrice + this.insurancePremium)}&nbsp;€</span>
                </button>
            </div>
        )
    }
}
